/* eslint-disable react-hooks/exhaustive-deps */
import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { customPost } from "../../utils/services";
import BreadCrumb from "../../components/common/BreadCrumb";
import Spinner from "../../components/common/Spinner";
import ModalSmall from "../../components/common/Modal";
import { Tab } from "@headlessui/react";
import { EyeIcon } from "@heroicons/react/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const thClass = "px-3 py-3 text-left text-xs font-semibold text-gray-700 bg-gray-50";
const tdClass = "px-3 py-2 text-xs text-gray-600 whitespace-nowrap";

const DetalleRow = ({ label, value }) => (
  <div className="grid grid-cols-2 gap-2 py-1.5 border-b border-gray-100 last:border-0">
    <span className="text-xs font-medium text-gray-500">{label}</span>
    <span className="text-xs text-primaryFont">{value ?? "-"}</span>
  </div>
);

export const MovimientosActuales = ({ hotel, restaurante, titulo }) => {
  const token = useSelector((state) => state.loginReducer.data.token);
  const [movimientos, setMovimientos] = useState([]);
  const [gastos, setGastos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detalle, setDetalle] = useState(null);
  const [tipoDetalle, setTipoDetalle] = useState("");

  useEffect(() => {
    setLoading(true);
    customPost({ hotel, restaurante }, `movimientos-actuales`, token)
      .then((data) => {
        const result = data?.data?.data ?? data?.data ?? [];
        setMovimientos(Array.isArray(result.movimientos) ? result.movimientos : []);
        setGastos(Array.isArray(result.gastos) ? result.gastos : []);
      })
      .finally(() => setLoading(false));
  }, [hotel, restaurante]);

  const totalMovimientos = movimientos.reduce((acc, m) => acc + Number(m.monto), 0);
  const totalGastos = gastos.reduce((acc, g) => acc + Number(g.monto), 0);

  const pages = [{ name: titulo, href: "/", current: false }];

  return (
    <div>
      <div className="flex flex-row justify-between items-end sm:flex mx-5 mt-2">
        <BreadCrumb navegacion={pages} />
      </div>

      <div className="mx-5 mt-2">
        <Tab.Group>
          <Tab.List className="flex rounded-xl bg-primaryOpacity p-1 mb-3">
            {["Movimientos", "Gastos"].map((tab) => (
              <Tab
                key={tab}
                className={({ selected }) =>
                  classNames(
                    "w-full rounded-lg py-2 text-sm font-medium leading-5 text-primaryFont",
                    "ring-white ring-opacity-60 ring-offset-2 focus:outline-none focus:ring-2",
                    selected ? "bg-white shadow" : "hover:bg-white/30"
                  )
                }
              >
                {tab}
              </Tab>
            ))}
          </Tab.List>

          <Tab.Panels>

            {/* ── Pestaña Movimientos ── */}
            <Tab.Panel>
              <div className="shadow border border-gray-300 rounded-lg overflow-x-auto bg-white">
                {loading ? (
                  <div className="my-10"><Spinner /></div>
                ) : movimientos.length === 0 ? (
                  <p className="text-center text-sm text-gray-500 my-10">No hay movimientos</p>
                ) : (
                  <>
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead>
                        <tr>
                          <th className={thClass}>ID</th>
                          <th className={thClass}>Usuario</th>
                          <th className={thClass}>Monto</th>
                          <th className={thClass}>Tipo Pago</th>
                          <th className={thClass}>Fecha</th>
                          <th className={thClass}>No. Documento</th>
                          <th className={thClass}>Referencia</th>
                          <th className={thClass}></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100 bg-white">
                        {movimientos.map((row) => (
                          <tr key={row.id} className="hover:bg-gray-50">
                            <td className={tdClass}>{row.id}</td>
                            <td className={tdClass}>{row.usuario}</td>
                            <td className={tdClass}>Q{Number(row.monto).toFixed(2)}</td>
                            <td className={tdClass}>{row.tipo_pago}</td>
                            <td className={tdClass}>{row.fecha}</td>
                            <td className={tdClass}>{row.no_documento ?? "-"}</td>
                            <td className={tdClass}>{row.referencia ?? "-"}</td>
                            <td className={tdClass}>
                              <button
                                type="button"
                                onClick={() => { setDetalle(row); setTipoDetalle("movimiento"); }}
                                className="hover:bg-blue-100 rounded-lg p-1 tooltip"
                              >
                                <EyeIcon className="h-4 w-4 text-blue-500" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="flex justify-end px-4 py-2 border-t bg-gray-50">
                      <span className="text-xs font-bold text-primaryFont">
                        Total: Q{totalMovimientos.toFixed(2)}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </Tab.Panel>

            {/* ── Pestaña Gastos ── */}
            <Tab.Panel>
              <div className="shadow border border-gray-300 rounded-lg overflow-x-auto bg-white">
                {loading ? (
                  <div className="my-10"><Spinner /></div>
                ) : gastos.length === 0 ? (
                  <p className="text-center text-sm text-gray-500 my-10">No hay gastos</p>
                ) : (
                  <>
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead>
                        <tr>
                          <th className={thClass}>ID</th>
                          <th className={thClass}>Descripcion</th>
                          <th className={thClass}>Monto</th>
                          <th className={thClass}>Categoria</th>
                          <th className={thClass}>Sub Categoria</th>
                          <th className={thClass}>Tipo Pago</th>
                          <th className={thClass}>Usuario</th>
                          <th className={thClass}>Fecha</th>
                          <th className={thClass}></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100 bg-white">
                        {gastos.map((row) => (
                          <tr key={row.id} className="hover:bg-gray-50">
                            <td className={tdClass}>{row.id}</td>
                            <td className={tdClass}>{row.descripcion}</td>
                            <td className={tdClass}>Q{Number(row.monto).toFixed(2)}</td>
                            <td className={tdClass}>{row.categoria?.nombre ?? "-"}</td>
                            <td className={tdClass}>{row.sub_categoria?.nombre ?? "-"}</td>
                            <td className={tdClass}>{row.tipo_pago?.nombre ?? "-"}</td>
                            <td className={tdClass}>{row.usuario}</td>
                            <td className={tdClass}>{row.created_at?.substring(0, 10)}</td>
                            <td className={tdClass}>
                              <button
                                type="button"
                                onClick={() => { setDetalle(row); setTipoDetalle("gasto"); }}
                                className="hover:bg-blue-100 rounded-lg p-1"
                              >
                                <EyeIcon className="h-4 w-4 text-blue-500" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="flex justify-end px-4 py-2 border-t bg-gray-50">
                      <span className="text-xs font-bold text-primaryFont">
                        Total: Q{totalGastos.toFixed(2)}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </Tab.Panel>

          </Tab.Panels>
        </Tab.Group>
      </div>

      {/* ── Modal detalle ── */}
      {detalle && (
        <ModalSmall
          title={tipoDetalle === "movimiento" ? `Movimiento #${detalle.id}` : `Gasto #${detalle.id}`}
          open={!!detalle}
          closeModal={() => {}}
          cerrar={() => setDetalle(null)}
        >
          <div className="p-4 space-y-1">
            {tipoDetalle === "movimiento" ? (
              <>
                <DetalleRow label="ID" value={detalle.id} />
                <DetalleRow label="Usuario" value={detalle.usuario} />
                <DetalleRow label="Monto" value={`Q${Number(detalle.monto).toFixed(2)}`} />
                <DetalleRow label="Tipo Pago" value={detalle.tipo_pago} />
                <DetalleRow label="Fecha" value={detalle.fecha} />
                <DetalleRow label="No. Documento" value={detalle.no_documento} />
                <DetalleRow label="Referencia" value={detalle.referencia} />
              </>
            ) : (
              <>
                <DetalleRow label="ID" value={detalle.id} />
                <DetalleRow label="Descripcion" value={detalle.descripcion} />
                <DetalleRow label="Monto" value={`Q${Number(detalle.monto).toFixed(2)}`} />
                <DetalleRow label="Categoria" value={detalle.categoria?.nombre} />
                <DetalleRow label="Sub Categoria" value={detalle.sub_categoria?.nombre} />
                <DetalleRow label="Tipo Pago" value={detalle.tipo_pago?.nombre} />
                <DetalleRow label="Usuario" value={detalle.usuario} />
                <DetalleRow label="Hotel" value={detalle.hotel === 1 ? "Sí" : "No"} />
                <DetalleRow label="Restaurante" value={detalle.restaurante === 1 ? "Sí" : "No"} />
                <DetalleRow label="Fecha" value={detalle.created_at?.substring(0, 10)} />
              </>
            )}
          </div>
        </ModalSmall>
      )}
    </div>
  );
};
